/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import makeStyles from '@mui/styles/makeStyles';
import { InputLabel, DataLine, Select } from 'components/elements';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function SelectControl({ isEditMode, name, options, control, labelText, label, rules, selectIcon }) {
  const classes = useStyles();
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { ref, value, ...restField }, fieldState: { error } }) =>
        isEditMode ? (
          <Select
            options={options}
            value={value}
            label={label || <InputLabel text={labelText} />}
            helperText={error ? error.message : null}
            error={!!error}
            {...restField}
            selectIcon={selectIcon}
          />
        ) : (
          <DataLine
            classes={classes.dataField}
            label={labelText}
            body={
              <>
                {selectIcon}
                {options.find((o) => o.value === value)?.label || value}
              </>
            }
          />
        )
      }
    />
  );
}

SelectControl.propTypes = {
  isEditMode: PropTypes.bool,
  name: PropTypes.string.isRequired,
  options: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.object), PropTypes.arrayOf(PropTypes.string)]),
  labelText: PropTypes.string,
  rules: PropTypes.shape({}),
  label: PropTypes.element,
  selectIcon: PropTypes.element,
  control: PropTypes.shape({}).isRequired,
};

SelectControl.defaultProps = {
  isEditMode: false,
  options: [],
  labelText: '',
  label: null,
  selectIcon: null,
  rules: {},
};

export default SelectControl;
